import axios, { AxiosInstance } from 'axios'
import { getCookieToken } from 'src/Global/Utils/index'
import { EMR_BACKEND_ENDPOINT_URL } from 'src/constants'

// Base paths used by consult-related endpoints
export const BASE_PATH = 'consult'
export const V1_BASE_PATH = '/v1/consults'

const api: AxiosInstance = axios.create({
  baseURL: EMR_BACKEND_ENDPOINT_URL,
})

// Request interceptor to always fetch the freshest token from cookies right before the request is sent.
api.interceptors?.request.use((config: any) => {
  const token = getCookieToken()
  if (token) {
    // Axios v1 uses AxiosHeaders; mutate instead of replacing
    if (!config.headers) config.headers = {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default api
